import { useMutation } from '@tanstack/react-query';
import type { LoginInput, LoginResponse } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';

interface LoginApiResponse {
  success: boolean;
  data: LoginResponse;
}

/**
 * Mutation hook for logging in an existing user.
 * Calls POST /auth/login.
 */
export function useLogin() {
  return useMutation<LoginResponse, Error, LoginInput>({
    mutationFn: async (input) => {
      const response = await apiClient.post<LoginApiResponse>('/auth/login', input);
      return response.data.data;
    },
  });
}
